import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom'
import { saveAs } from 'file-saver';
//var dateFormat = require('dateformat');


const RenderSadfinder = () => {
let emptySadfinder={};
var emptyselectedsad;


const resturl=sessionStorage.getItem("REST_URL");

const navigate = useNavigate();
const location = useLocation();

window.addEventListener("keypress", function (event) {
 // detect event key
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});

const [tblitems, setTblitems] = useState([]);
const [tblsadfinder, setTblsadfinder] = useState([]);
const [yearoptions, setYearoptions] = useState([]);
const [coloroptions, setColoroptions] = useState([]);
const [city, setCity] = useState({name:''});
const [tbldetails, setTbldetails] = useState([]);
const [statusoptions, setStatusoptions] = useState([]);

const [cmpoptions, setCmpoptions] = useState([]);
const [decoptions, setDecoptions] = useState([]);
const [tblsadcntmthyear, setTblsadcntmthyear] = useState([]);
const [tblsadcntmthcalend, setTblsadcntmthcalend] = useState([]);
const [dowait, setDowait] = useState({show:false});



const [cuocods, setCuocods]= useState([
<option key="cuo0" value="" >***</option>
,<option key="cuo1" value="XSC" >XSC</option>
,<option key="cuo2" value="SCD" >SCD</option>
,<option key="cuo3" value="GTSD" >GTSD</option>
,<option key="cuo4" value="PAP" >PAP</option>
,<option key="cuo5" value="PSD" >PSD</option>

]);

const [sadfinder, setSadfinder] = useState({
 regDat1:''
, regDat2:''
, decRefYear1:''
, amtTbp1:''
, amtTbp2:''
, regNbr1:''
, cmpNam1:''
, decNam1:''
, expNam1:''
, colDsc:'All Colors'
, trkStatus1:'Assessed'
});

const [crit, setCrit] = useState({
date1:''
, color:''
, status:''
, regnbr:''
, cmpcod:''
, deccod:''
, yearname:''
, decorcmp_name:''
, IDE_CUO_COD:''
, TPT_LOC:''
, YRMM:''
, unpaiddeclar:'exclude'
});
//, decorcmp_name:''



useEffect(() => {
	
	if (tblsadcntmthyear.length>0){
		openCity(null, "officemonths");
		if (cmpoptions.length==0)
			getsadcmpoptions();
		}
		
		
 },[JSON.stringify(tblsadcntmthyear)]);
 
 
 
 
useEffect(() => {
	
		if (tblsadcntmthcalend.length>0)
			setcalendarcolor(crit.date1);
		
 },[JSON.stringify(tblsadcntmthcalend)]);
 
useEffect(() => {
	
	if (crit.yearname!="" && crit.unpaiddeclar!="")
		gettblsadcntmthyear();
		
 },[crit.yearname, crit.unpaiddeclar]);
 
 
 


useEffect(() => {
	
	console.log("crit.IDE_CUO_COD: "+crit.IDE_CUO_COD);
	
	if (crit.IDE_CUO_COD==""){
		setTblsadcntmthcalend([]);
		setTblsadfinder([]);
		openCity(null, "officemonths");
		}
	else
		gettblsadcntmthcalend();

 },[crit.IDE_CUO_COD]);

	
useEffect(() => {
	
	emptySadfinder=sadfinder;
	
	if (!sessionStorage.getItem("AW_USERNAME")){
	navigate("../logout");
	return;
	}
	


getyearoptions();
resetColoroptions();
resetFinderCriteria();
resetStatusoptions();


//emptyselectedsad=selectedsad;
if (document.getElementsByName("critname")[0])
	document.getElementsByName("critname")[0].focus();
//sadfinder.regDat1


	  },[]);



  const handleFocus = (e) => {
  //e.target.blur();
  if (e.target.readOnly)
	e.target.style.background='gainsboro';
/*
else 
	e.target.select();
*/
	e.target.select();

	}//end func

function openCity(evt, cityName) {
	
	if (evt)
		evt.preventDefault();
	
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

if (evt)
	if (evt.currentTarget)
		evt.currentTarget.className += " active";
	
  setCity({name:cityName});
  
  if (document.getElementsByName("regnbr")[0])
	  document.getElementsByName("regnbr")[0].focus();
  
}//end func

function resetColoroptions(){
let htmrows=[];

const colors='All Colors,Red,Yellow,Blue,Green'.split(',');
for (var i=0; i<colors.length; i++){
	const color=colors[i];
	const key='coloroption'+color;
	
	const value=(color.startsWith("All"))?"":color;
	
	htmrows.push(<>
	<option key={key} value={value} >{color}</option>
	</>);
	}

setColoroptions(htmrows);

/*
let currentYear = new Date().getFullYear();
for (var i=0; i<15; i++){
	const yr=currentYear-i;
	const key='yroption'+yr;
	htmrows.push(<>
	<option key={key} value={yr} >{yr}</option>
	</>);
	if (i==0)
		setCrit((prev)=>{
			return {...prev, year:yr}
			});

	
	}//end for
setYearoptions(htmrows);
*/

}//end func


function callSetCrit(e){
	
	const {name,value}=e.target;
	
	console.log('callSetCrit: '+name+', '+value);
	
	setCrit((prev)=>{
		return {...prev, [name]:value}
	});
	
}//end func






function openSad(e, instanceid){
e.preventDefault();


const state={
			sad_payment_groupid:0
			,instanceid:instanceid
			,from_sad_finder:1
			};
//from_sad_finder guides the return icon on sad form

navigate(`/sad`,{state:state});
}//end func


function resetStatusoptions(){
const arrOptions="Assessed,Exited,Stored,Paid,Registered,Cancelled".split(",");
let arrJsx=[];

arrOptions.map((opt, index) => {
	const key="statusopt_"+index;
	arrJsx.push(<option value={opt} key={key} >{opt}</option>);
	});

setStatusoptions(arrJsx);
}//end func

function resetFinderCriteria(){
  const currYr=new Date().getFullYear();
setSadfinder({
 decRefYear1: currYr
, cmpNam1:''
, expNam1:''
, decNam1:''
, regNbr1:''
, trkStatus1:''
, colDsc:'All'
});

}//end func


async function getsadcmpoptions(){

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };

setDecoptions([]);
setCmpoptions([]);
await  fetch(resturl+'rarsad/getsadcmpoptions',requestOptions)
      .then(res => res.json())
      .then(res => aftergetsadcmpoptions(res))
      .catch(err => console.log(err));
	  

}//end func  

function aftergetsadcmpoptions(res){

if (!res.length)
	return;


let cmptemp=[], dectemp=[];

res.map((col, index) => {
	const tbl=col['TBL'];
	const key=tbl+"_opts_"+index;
	
	if (tbl=="DECTAB")
		dectemp.push(<option key={key} value={col['COD']} >{col['NAM']}</option>);
	else if (tbl=="CMPTAB")
		cmptemp.push(<option key={key} value={col['COD']} >{col['NAM']}</option>);
	
	});//end map

setCmpoptions(cmptemp);
setDecoptions(dectemp);
	
}//end func  

async function gettblsadcntmthcalend(){

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {IDE_CUO_COD:crit.IDE_CUO_COD, YRMM:crit.YRMM} )
  };


document.getElementById("tblsadcntmthyear").style.visibility="hidden";
await  fetch(resturl+'rarsad/tblsadcntmthcalend',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblsadcntmthcalend(res))
      .catch(err => console.log(err));
	  

}//end func  

function aftergettblsadcntmthcalend(res){

document.getElementById("tblsadcntmthyear").style.visibility="visible";	

openCity(null, "sadfinderresults");

if (!res.length)
	return;

let temp=[];
let LAST_SAD_DATE="";
res.map((col, index) => {
	const key="tblcalend_"+index;
//	const SUN_DATE=col['SUN_DATE'];
	const WEEK_TOTAL=col['WEEK_TOTAL']?col['WEEK_TOTAL']:"";

	if (col['BAND']=='02')
	temp.push(	<tr key={key} >
				<td align="center" id={"calend_"+col['SUN']} ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['SUN']);}} >{col['SUN']?.substring(8,10)}</a></td>
				<td align="center" id={"calend_"+col['MON']} ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['MON']);}} >{col['MON']?.substring(8,10)}</a></td>
				<td align="center" id={"calend_"+col['TUE']} ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['TUE']);}} >{col['TUE']?.substring(8,10)}</a></td>
				<td align="center" id={"calend_"+col['WED']} ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['WED']);}} >{col['WED']?.substring(8,10)}</a></td>
				<td align="center" id={"calend_"+col['THU']} ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['THU']);}} >{col['THU']?.substring(8,10)}</a></td>
				<td align="center" id={"calend_"+col['FRI']} ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['FRI']);}} >{col['FRI']?.substring(8,10)}</a></td>
				<td align="center" id={"calend_"+col['SAT']} ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['SAT']);}} >{col['SAT']?.substring(8,10)}</a></td>
				<td align="center" >{WEEK_TOTAL}</td>
				</tr>
				);
	else if (col['BAND']=='01'){
		if (LAST_SAD_DATE==""){
			LAST_SAD_DATE=col['LAST_SAD_DATE'];
			setCrit((prev)=>{
				return {...prev, date1:LAST_SAD_DATE}
			});
			}//end if
			
		
			temp.push(	<><tr key={key} >
				<td align="center" colSpan="3" >{crit.YRMM}</td>
				<td align="center" ></td>
				<td align="center" colSpan="3" >Total # entries:</td>
				<td align="center" >{WEEK_TOTAL}</td>
				</tr>
				
				 
				 <tr>
				 <th>Sun</th>
				 <th>Mon</th>
				 <th>Tue</th>
				 <th>Wed</th>
				 <th>Thu</th>
				 <th>Fri</th>
				 <th>Sat</th>
				 <th>Week<br/>Total</th>
				 </tr>
				 
				</>
				);
				
		}//end else if

				});//end map

setTblsadcntmthcalend(temp);

}//end func


async function dateChange(e, date1){
e.preventDefault(e);
let temp=crit;
temp.date1=date1;
setCrit(temp);

setcalendarcolor(date1);

		
/*
setCrit((prev)=>{
	return {...prev, date1:date1}
	});
let temp=crit;
temp.date1=date1;
setCrit(temp);

*/

	openCity(null, "sadfinderresults");
}//end func
	
	
function setcalendarcolor(date1){
		
		
		for (var i=1; i<=31; i++){
			const num=i<10?"0"+i:i;
			const currdate=crit.YRMM+"-"+num;
			const elem=document.getElementById("calend_"+currdate);
			if (elem){
				//console.log("match date1 with elem calend_"+currdate);
				if (currdate==date1){
					if (!elem.classList.contains("calendcurrdate"))	{elem.classList.add("calendcurrdate");}
					}//end if
				else{
					if (elem.classList.contains("calendcurrdate"))	{elem.classList.remove("calendcurrdate");}
					}//end else
					
				}//end if
			}//end for
		
		
}//end func
	
function submitform1(e){
e.preventDefault();	
//clickMonthOffice(e, IDE_CUO_COD, YRMM);
callsadfinder(e);
openCity(null, "sadfinderresults");
}//end func
	
async function callsadfinder(e){
	e.preventDefault();	
/*
if (crit.date1=="")	{
	showsnackbar("please click a date first");
	return;
	}

*/
	
let params=crit;
params.USERNAME=sessionStorage.getItem("AW_USERNAME");

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( crit )
  };

setDowait({show:true});
document.getElementById("btnsearch").style.visibility="hidden";

setTblsadfinder([]);

await  fetch(resturl+'rarsad/sadfinder',requestOptions)
      .then(res => res.json())
      .then(res => aftercallsadfinder(res))
      .catch(err => console.log(err));
	  

}//end func  

function aftercallsadfinder(res){
	
setDowait({show:false});
	document.getElementById("btnsearch").style.visibility="visible";
	
if (!res.length)
	return;
	
let htmrows=[];

//<img src='images/pdficon_small.gif' border=0 title='click to download voucher' />
/*
<input  type="radio" name="cbsad"  id={sadlinkid} onClick={(e)=>{openSad(e, col['INSTANCEID']);}}  /><label className="hand" htmlFor={sadlinkid} >&nbsp;{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</label>
<a href="#" target="_blank" className="nodecor" onClick={(e)=>{openSad(e, col['INSTANCEID']);}} >{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</a>
window.open(this.makeHref("sad"))
<a href="#" target="_blank" onClick={(e) => {openSad(e, instanceId); }} >{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</a>
<Link to={{pathname: "/sad", state:{instanceid:instanceId, sad_payment_groupid:0}  }} target="_blank" >{col['IDE_REG_SER']+' '+col['IDE_REG_NBR']}</Link>
*/
res.map((col, index) => {
	const key='sadfinder'+index;
	const sadlinkid='sadlinkid'+index;
	const instanceId=col['INSTANCEID'];
	const currstate={instanceid:instanceId, sad_payment_groupid:0};
	console.log("currstate: "+JSON.stringify(currstate));
	
	htmrows.push(<tr key={key} >
		<td align="right" >{index+1}</td>
		<td align="left" >{col['IDE_CUO_COD']}</td>
		<td align="left" >
		<a href="#" target="_blank" className="nodecor" onClick={(e) => {openSad(e, instanceId); }} >{col['REG_NBR']}</a>
		</td>
		<td align="left" >{col['DEC_COD']}</td>
		<td align="right" >{col['PTY_NBR_ITM']}</td>
		<td align="right" >{col['STR_FIN_AMT_TBP']}</td>
		<td align="center" >{col['STR_RCP_DAT']}</td>
		<td align="left" >{col['STR_CON_NAM']}</td>
		</tr>
		);

	});//end map
	

setTblsadfinder(htmrows);	
	

/*
document.getElementById('btndosearch').style.display='block';
document.getElementById('imgwaitsearch').style.display='none';

*/
	
}//end func

function clickMonthOffice(e, IDE_CUO_COD, YRMM){
	console.log("clickMonthOffice IDE_CUO_COD: "+IDE_CUO_COD);
	
	if (e)
		e.preventDefault();

/*
normally reset regnbr to empty as when user click a month and office.
But for the quick search of regnbr (without office), obviously the regnbr must remain
*/
const regnbr=(IDE_CUO_COD=="")?crit.regnbr:"";


	setCrit((prev)=>{
		return {
			...prev
			, regnbr:regnbr
			, IDE_CUO_COD: IDE_CUO_COD
			, YRMM: YRMM
			}
	});


/*
let tempcrit=crit;
tempcrit.IDE_CUO_COD=IDE_CUO_COD;
tempcrit.YRMM=YRMM;
setCrit(tempcrit);

	setCrit((prev)=>{
		return {
			...prev
			, IDE_CUO_COD: IDE_CUO_COD
			, YRMM: YRMM
			}
	});
*/

}//end func

async function gettblsadcntmthyear(){
	

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {yearname: crit.yearname, unpaiddeclar:crit.unpaiddeclar} )
  };

setTblsadcntmthyear([]);
setDowait({show:true});

 await fetch(resturl+'rarsad/tblsadcntmthyear',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblsadcntmthyear(res))
      .catch(err => console.log(err));

}//end func

/*
the month loop was previously for fiscal year
		for (var i=4; i<=15; i++){
			const mm=(i>12)?i%12:i;
			
			const colNam=(mm<10)?"AMT0"+mm:"AMT"+mm;
			ARRAY_YRMM.push(col[colNam]);
			}//end for
*/

function aftergettblsadcntmthyear(res){

setDowait({show:false});

if (!res.length)
	return;

let temp=[];
let ARRAY_YRMM=[];
let rownum=1;
res.map((col, index) => {
	const key="tblcuomonth_"+index;
	
	
	const BAND=col['BAND'];
	
	if (BAND=="01"){
		for (var i=1; i<=12; i++){
			
			const colNam=(i<10)?"AMT0"+i:"AMT"+i;
			ARRAY_YRMM.push(col[colNam]);
			}//end for
		
		}
	else if (BAND=="02"){

		if (temp.length==0)
			console.log("ARRAY_YRMM: "+JSON.stringify(ARRAY_YRMM));


	temp.push(	<tr key={key} >
				<td align="right" >{rownum}</td>
				<td align="center" >{col['IDE_CUO_COD']}</td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[0]);}} >{col['AMT01']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[1]);}} >{col['AMT02']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[2]);}} >{col['AMT03']}</a></td>

				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[3]);}} >{col['AMT04']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[4]);}} >{col['AMT05']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[5]);}} >{col['AMT06']}</a></td>

				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[6]);}} >{col['AMT07']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[7]);}} >{col['AMT08']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[8]);}} >{col['AMT09']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[9]);}} >{col['AMT10']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[10]);}} >{col['AMT11']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{clickMonthOffice(e, col['IDE_CUO_COD'], ARRAY_YRMM[11]);}} >{col['AMT12']}</a></td>
				<td align="right" >{col['TOTAL']}</td>
				</tr>
				);
				rownum+=1;
		}//end else
			
		
			else if (BAND=="03"){

	

	temp.push(	<tr key={key} style={{fontWeight:"bold"}} >
				<td align="right" ></td>
				<td align="left" >Total</td>
				<td align="right" >{col['AMT01']}</td>
				<td align="right" >{col['AMT02']}</td>
				<td align="right" >{col['AMT03']}</td>

				<td align="right" >{col['AMT04']}</td>
				<td align="right" >{col['AMT05']}</td>
				<td align="right" >{col['AMT06']}</td>

				<td align="right" >{col['AMT07']}</td>
				<td align="right" >{col['AMT08']}</td>
				<td align="right" >{col['AMT09']}</td>
				<td align="right" >{col['AMT10']}</td>
				<td align="right" >{col['AMT11']}</td>
				<td align="right" >{col['AMT12']}</td>
				<td align="right" style={{color:"brown"}} >{col['TOTAL']}</td>
				</tr>
				);
				
		}//end else
		
	});//end map

setTblsadcntmthyear(temp);


}//end func


async function getyearoptions(){
	

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };

 await fetch(resturl+'rarsad/getyearoptions',requestOptions)
      .then(res => res.json())
      .then(res => aftergetyearoptions(res))
      .catch(err => console.log(err));

}//end func

function aftergetyearoptions(res){

if (!res.length)
	return;

let temp=[];
let firstyearname=crit.yearname;
res.map((col, index) => {
	const key="yearoptions_"+index;
	const yearname=col['YEARNAME'];
	//let selected="";
	console.log("LATEST_SAD_DATE "+col['LATEST_SAD_DATE']);
	if (col['LATEST_SAD_DATE']!=null && firstyearname==""){
		firstyearname=yearname;
		//selected=" selected ";
		}//end func
		
	
	temp.push(<option key={key+"_cod"} value={yearname} >{yearname}</option>);
	});//end map

setYearoptions(temp);
setCrit((prev)=>{
	return {...prev, yearname:firstyearname}
	});
}//end func

function clearSearch(e){
	
	e.preventDefault();
	resetFinderCriteria();
	document.getElementsByName('regNbr1')[0].focus();
	console.log('clearSearch');
  

}//end func


function handleCritChange(e) {
//destructure an array of objects in JavaScript
e.preventDefault(); 
const {name, value}=e.target;
	

	setCrit((prev) => {
	return {...prev, [name]:value}
	},console.log('handleCritChange after  ') );
	
}//end func








function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func



async function getxlfilename(e, flag){
	e.preventDefault();
	
	if (crit.YRMM=="" && flag!="ytdsummary"){
		showsnackbar("click a month first");
		return;
		}

	if ( (flag=="sadcount" || flag=="saditem") && crit.YRMM=="" && crit.deccod=="" && crit.cmpcod==""){
		showsnackbar("select a month or declarant or importer first");
		return;
		}
		
	if (flag=="outstandbol" && crit.decorcmp_name.trim().length<4){
		showsnackbar("enter part of the BOL consignee name first");
		document.getElementsByName("decorcmp_name")[0].focus();
		return;
		}
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };	
  
  await  fetch(resturl+'rarawxlreport/getxlfilename',requestOptions)
      .then(res => res.json())
      .then(res => 	{
		  if (flag=="sadcount")
			  rptSadcount(res);
		  else if (flag=="saditem")
			  rptSaditem(res);
		  else if (flag=="epustats")
			  rptEpustats(res);
		  else if (flag=="ytdsummary")
			  rptYtdsummary(res);
		  else if (flag=="outstandbol")
			  rptOutstandbol(res);
		  
		  
	  }  )
      .catch(err => console.log(err));
	  
}//end func


async function rptOutstandbol(res){
	
let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="CUSTOMS_OUTSTANDING_BOLS_"+res[0].FILE_NAME;


const params={
	username: sessionStorage.getItem("USERNAME")
	, yrmm: crit.YRMM
	, bolconnam: crit.decorcmp_name
   , filename:FILE_NAME 
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

document.getElementById("btnexcel4").style.visibility="hidden";

await  fetch(resturl+'rarawxlreport/rptoutstandbolxl',requestOptions)
      .then(res => 	afterrptoutstandbol(res, FILE_NAME) )
      .catch(err => console.log(err));

}//end func
	
async function afterrptoutstandbol(res, FILE_NAME){
	document.getElementById("btnexcel4").style.visibility="visible";
		const pBlob = await res.blob();
	var blob = new Blob([pBlob], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
saveAs(blob, FILE_NAME+".xlsx");

}//end func


async function rptYtdsummary(res){
	
let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="CUSTOMS_REVENUE_SIGTAS_"+res[0].FILE_NAME;


const params={
	username:sessionStorage.getItem("USERNAME")
	, currdate:crit.YRMM==''?'':crit.YRMM+"-01"
, filename:FILE_NAME 
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

document.getElementById("btnexcel3").style.visibility="hidden";

await  fetch(resturl+'rarawxlreport/rptytdsummryxl',requestOptions)
      .then(res => 	afterrptytdsummary(res, FILE_NAME) )
      .catch(err => console.log(err));

}//end func
	
async function afterrptytdsummary(res, FILE_NAME){
	document.getElementById("btnexcel3").style.visibility="visible";
		const pBlob = await res.blob();
	var blob = new Blob([pBlob], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
saveAs(blob, FILE_NAME+".xlsx");

}//end func


async function rptEpustats(res){
	
let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="EPU_OFFICERS_STATS_"+res[0].FILE_NAME;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {username:sessionStorage.getItem("USERNAME"), yrmm:crit.YRMM, filename:FILE_NAME } )
  };		

document.getElementById("btnexcel2").style.visibility="hidden";

await  fetch(resturl+'rarawxlreport/rptepustats',requestOptions)
      .then(res => 	afterrptepustats(res, FILE_NAME) )
      .catch(err => console.log(err));

}//end func
	
async function afterrptepustats(res, FILE_NAME){
	document.getElementById("btnexcel2").style.visibility="visible";
		const pBlob = await res.blob();
	var blob = new Blob([pBlob], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
saveAs(blob, FILE_NAME+".xlsx");

}//end func


async function rptSaditem(res){
	
let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="CustomsDeclarationItems_"+res[0].FILE_NAME;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {username:sessionStorage.getItem("USERNAME"), crit:crit, filename:FILE_NAME } )
  };		

setDowait({show:true});

await  fetch(resturl+'rarawxlreport/rptawsaditemxl',requestOptions)
      .then(res => 	afterrptawsadsxl(res, FILE_NAME) )
      .catch(err => console.log(err));

}//end func

async function rptSadcount(res){
	
let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="CustomsDeclarations_"+res[0].FILE_NAME;
//username+"', '"+crit.yrmm+"', '"+crit.deccod+"', '"+crit.cmpcod
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {username:sessionStorage.getItem("USERNAME"), crit:crit, filename:FILE_NAME } )
  };		

setDowait({show:true});

await  fetch(resturl+'rarawxlreport/rptawsadsxl',requestOptions)
      .then(res => 	afterrptawsadsxl(res, FILE_NAME) )
      .catch(err => console.log(err));

}//end func
	
async function afterrptawsadsxl(res, FILE_NAME){
	
	setDowait({show:false});
		const pBlob = await res.blob();
	var blob = new Blob([pBlob], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
saveAs(blob, FILE_NAME+".xlsx");

}//end func



function clickReturn(e){
	e.preventDefault();
	setCrit((prev)=>{
		return {
			...prev
			, IDE_CUO_COD:""
			, YRMM:""
			, date1:""
		}
	});
	
	openCity(null, "officemonths");
}//end func

function setYRMM(e, mm){
	
		setCrit((prev)=>{
		return {...prev, YRMM: crit.yearname+"-"+mm}
	});
	
}//end func

function calendyrChange(e){
	setCrit((prev)=>{
		return {...prev, yearname:e.target.value}
	});
}//end func




const tblCalend=<table align="center" className="customers" border="0" cellSpacing="0" cellPadding="0"  >
 <tbody>
 {tblsadcntmthcalend}
 </tbody>
</table>;


let SHARED_FOLDER="file://///ASYCUDADEVHOST.TCIG.TC\\Reconciliation";
if (sessionStorage.getItem("SHARED_FOLDER")!="")
	SHARED_FOLDER=sessionStorage.getItem("SHARED_FOLDER");

  return (
    <>
<div align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"22px"}} >Table of Monthly Declarations count per Customs Office</div>

<div id="officemonths" align="center" className="tabcontent autolrmargin centercols1-1" style={{marginBottom:"12px" }} >
<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
<select name="yearname" onChange={(e)=>{calendyrChange(e);}} value={crit.yearname} >
{yearoptions}
</select>
&nbsp;
<input name="regnbr" type="text" required value={crit.regnbr} onChange={(e)=>{handleCritChange(e);}} placeholder="regis. #" size="4" style={{textAlign:"center"}} onFocus={(e)=>{e.target.select();}} autoComplete="off" />
&nbsp;
<input name="decorcmp_name" type="text" value={crit.decorcmp_name} onChange={(e)=>{handleCritChange(e);}} placeholder="broker/importer code/name" style={{textAlign:"center"}} size="22" autocomplete="off" />
<input type="image" src="img/transparent.png" border="0" />
<table align="center">
 <tbody>
 <tr>
	<td align='right' >Unpaid Declarations filter:</td>
	<td align='left' >
	 <select name="unpaiddeclar" value={crit.unpaiddeclar} onChange={(e)=>{handleCritChange(e);}} >
	 <option value='exclude' >Exclude Unpaid Declarations</option>
	 <option value='include' >Include Unpaid Declarations</option>
	 <option value='only' >Only Unpaid Declarations</option>
	 </select>
	</td>
 </tr> 
 </tbody>
</table>
 </form>

 		{
		dowait.show==true && 
		<div align='center' style={{width:"90%"}}  ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div>
		}
		
{!dowait.show && <>
<table className="customers" id="tblsadcntmthyear" >
 <thead>
 <tr>
 <th>#</th>
 <th>Office</th>
 <th><input type="radio" name="rdmonth" value="1" id="rdmm01" onClick={(e)=>{setYRMM(e,'01');}} /><br/><label htmlFor="rdmm01" className="hand" >Jan</label></th>
 <th><input type="radio" name="rdmonth" value="2" id="rdmm02" onClick={(e)=>{setYRMM(e,'02');}} /><br/><label htmlFor="rdmm02" className="hand" >Feb</label></th>
 <th><input type="radio" name="rdmonth" value="3" id="rdmm03" onClick={(e)=>{setYRMM(e,'03');}} /><br/><label htmlFor="rdmm03" className="hand" >Mar</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm04" onClick={(e)=>{setYRMM(e,'04');}} /><br/><label htmlFor="rdmm04" className="hand" >Apr</label></th>
 
 <th><input type="radio" name="rdmonth" value="4" id="rdmm05" onClick={(e)=>{setYRMM(e,'05');}} /><br/><label htmlFor="rdmm05" className="hand" >May</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm06" onClick={(e)=>{setYRMM(e,'06');}} /><br/><label htmlFor="rdmm06" className="hand" >Jun</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm07" onClick={(e)=>{setYRMM(e,'07');}} /><br/><label htmlFor="rdmm07" className="hand" >Jul</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm08" onClick={(e)=>{setYRMM(e,'08');}} /><br/><label htmlFor="rdmm08" className="hand" >Aug</label></th>

 <th><input type="radio" name="rdmonth" value="4" id="rdmm09" onClick={(e)=>{setYRMM(e,'09');}} /><br/><label htmlFor="rdmm09" className="hand" >Sep</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm10" onClick={(e)=>{setYRMM(e,'10');}} /><br/><label htmlFor="rdmm10" className="hand" >Oct</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm11" onClick={(e)=>{setYRMM(e,'11');}} /><br/><label htmlFor="rdmm11" className="hand" >Nov</label></th>
 <th><input type="radio" name="rdmonth" value="4" id="rdmm12" onClick={(e)=>{setYRMM(e,'12');}} /><br/><label htmlFor="rdmm12" className="hand" >Dec</label></th>
 
 <th>Year<br/>Total</th>
 </tr>
 </thead>
 <tbody>
  {tblsadcntmthyear}
 </tbody>
 </table>
 
 <table align="center" style={{marginTop:"6px"}} >
 <tbody>
 <tr>
	<td align='right' >Declarant filter:</td>
	<td align='left' >
	 <select name="deccod" value={crit.deccod} onChange={(e)=>{handleCritChange(e);}} >
	 <option value='' >***declarants***</option>
	 {decoptions}
	 </select>
	</td>
 </tr>
 <tr>
	<td align='right' >Importer filter:</td>
	<td align='left' >
	 <select name="cmpcod" value={crit.cmpcod} onChange={(e)=>{handleCritChange(e);}} >
	 <option value='' >***importers***</option>
	 {cmpoptions}
	 </select>
	</td>
 </tr>

 </tbody>
 </table>



{!dowait.show && <>
 <div align="center" style={{marginTop:"18px"}} >
<a href="#" className="nodecor" id="btnexcel1" onClick={(e)=>{getxlfilename(e, 'saditem');}} ><img src="img/msexcel.gif" border="0" /> SAD Itemized report for selected month</a>
 </div>
 <div align="center" style={{marginTop:"18px"}} >
 <a href="#" className="nodecor" id="btnexcel1" onClick={(e)=>{getxlfilename(e, 'sadcount');}} ><img src="img/msexcel.gif" border="0" /> SAD count report for selected month</a>
 </div>
 <div align="center" style={{marginTop:"18px"}} >
 <a href="#" className="nodecor" id="btnexcel2" onClick={(e)=>{getxlfilename(e, 'epustats');}} ><img src="img/msexcel.gif" border="0" /> EPU stats report for selected month</a>
 </div>
 <div align="center" style={{marginTop:"18px"}} >
 <a href="#" className="nodecor" id="btnexcel4" onClick={(e)=>{getxlfilename(e, 'outstandbol');}} ><img src="img/msexcel.gif" border="0" /> Outstanding Bills of Lading</a>
 </div>
 </>
}

 </>
}
</div>

<div align="center" id="sadfinderresults" className="tabcontent"  style={{marginBottom:"6px", marginTop:"9px"}} >

<a href="#" className="nodecor" onClick={(e)=>{clickReturn(e);}} ><img src="img/return.png" border="0" /> return to Customs Office & Months Table</a>



	<table align="center" border="0" width="50%"  >
	 <tbody>
	 <tr valign="top" >
	 <td align="center">
		{tblCalend}
	</td>
	 <td align="left">

	 <table align="center" border="0"  >
	 <tbody>
	 <tr>
	 <td align="left" ><select name="IDE_CUO_COD" value={crit.IDE_CUO_COD} onChange={(e)=>{handleCritChange(e); }} >{cuocods}</select></td>
	 <td align="left" ><select name="trkStatus1" value={crit.trkStatus1} onChange={(e)=>{handleCritChange(e); }} >{statusoptions}</select></td>
	</tr>

	 <tr>
	 <td align="left" ><select name="colDsc" value={crit.colDsc} onChange={(e)=>{handleCritChange(e); }} >{coloroptions}</select></td>
	 <td align="left" ><input name="regnbr" placeholder="regis. #" size="6"  className="tlnctr"  value={crit.regnbr} onChange={(e)=>{callSetCrit(e);}} autoComplete="false" style={{textAlign:"center"}} onFocus={(e)=>{e.target.select();}} /></td>
	</tr>

	 	
	 <tr>
	 <td align="center"  colSpan="2"  ><input name="decorcmp_name" placeholder="declarant or importer name"  value={crit.decorcmp_name} onChange={(e)=>{callSetCrit(e);}} autoComplete="false" onFocus={(e)=>{e.target.select();}}  /></td>
	</tr>

	 <tr>
	 <td align="center" colSpan="2" >
	 {/*<button className="button" id="btnsearch" style={{width:"100%"}} onClick={(e)=>{callsadfinder(e); }} >search</button>*/}
	 <a href="#" id='btnsearch' className="nodecor" onClick={(e)=>{callsadfinder(e); }} ><img src="img/Btn_Search_Normal.png" height="28" border="0" /></a>
	 <br/><input size="7" readOnly className="gnsbro" name="date1" value={crit.date1} onChange={(e)=>{callSetCrit(e);}} style={{textAlign:"center",fontSize:"12px",border:"none"}} />
	 </td>
	</tr>
	
	

	 </tbody>
	 </table>
	 
	 </td>
	 </tr>
	 </tbody>
	</table>

<div className="altolrmargin centercols1-1" >
 <table className="customers"  >
 <thead>
 <tr>
 <th>#</th>
 <th>Office</th>
 <th>Reg<br/>Nbr</th>
 <th>Dec<br/>Cod</th>
 <th>Items</th>
 <th>Amt<br/>Assessed</th>
 <th>Rcp<br/>Date</th>
 <th>Consignee<br/>Name</th>
 </tr>
 </thead>


 <tbody>
		{
		!dowait.show==true && tblsadfinder
		}
 </tbody>
 </table>
 		{
		dowait.show==true && 
		<div align='center' style={{width:"90%"}}  ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div>
		}
</div>


</div>

<div align='center' id="snackbar" ></div>


	

    </>
  );
};

export default RenderSadfinder;